import { Component, OnInit, Input } from '@angular/core';
import { egretAnimations } from '../../shared/animations/egret-animations';
import { Router } from '@angular/router';
import { AgentProfileService } from '../../shared/services/agent-profile.service';
import { Subscription } from 'rxjs';
import { Broadcaster } from '../../shared/services/broadcaster.service';

@Component({
  selector: 'main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  animations: egretAnimations,
})
export class MainLayoutComponent implements OnInit {
  private agentWelcomePopupFlag: boolean;
  private agentInfo;

  public agentProfileReadySub: Subscription;
  private remainingLicences: number = 0;
  private fetchungLicenceData: boolean = true;

  constructor(
    private router: Router,
    public agentProfileService: AgentProfileService,
    public broadcaster: Broadcaster,
  ) {}
  ngOnInit() {
    if (!this.agentProfileService.readyAgent) {
      this.agentProfileReadySub = this.agentProfileService.agentFetched.subscribe(
        val => {
          this.agentInfo = val;
          this.agentWelcomePopupFlag = this.agentInfo.welcomePopup
            ? false
            : true;
        },
      );
    } else {
      this.agentInfo = this.agentProfileService.readyAgent;
      this.agentWelcomePopupFlag = this.agentInfo.welcomePopup ? false : true;
    }
    this.fetchungLicenceData = true;
    this.agentProfileService.fethcLicenceCount().subscribe(
      res => {
        if (res && res[0]) {
          this.remainingLicences = res[0].remaining_licenses || 0;
        } else {
          this.remainingLicences = 0;
        }
        this.fetchungLicenceData = false;
      },
      err => {
        this.fetchungLicenceData = false;
      },
    );
  }

  navigate(path) {
    switch (path) {
      case 'contacts':
        this.router.navigate(['/contacts']);
        break;
      case 'addcontact':
        this.router.navigate(['/contacts', { action: 'add' }]);
        break;
      case 'marketplace':
        this.router.navigate(['/property-marketplace']);
        break;
      case 'addowners':
        this.router.navigate(['/contacts', { action: 'owners' }]);
        break;
      case 'properties':
        this.router.navigate(['/properties']);
        break;
      case 'addproperty':
        this.broadcaster.activatePopup('addproperty');
        this.router.navigate(['/properties']);
        break;
      case 'help':
        if (<any>window && (<any>window).Intercom) {
          (<any>window).Intercom('show');
        }
        break;
      case 'licenses':
        this.router.navigate(['/licenses']);
        break;
      default:
        break;
    }
  }
}
